import { render, staticRenderFns } from "./horses.vue?vue&type=template&id=5cab942e&scoped=true&"
import script from "./horses.vue?vue&type=script&lang=js&"
export * from "./horses.vue?vue&type=script&lang=js&"
import style0 from "./horses.vue?vue&type=style&index=0&id=5cab942e&lang=scss&scoped=true&"
import style1 from "./horses.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cab942e",
  null
  
)

/* custom blocks */
import block0 from "./horses.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
